import {setSystemInformationData} from 'stores/actions/aboutStateAction';
import {setManualReteachReturnToCaddy} from 'stores/actions/reteachPlateAction';
import {
  setInstrumentServiceStatus,
  setInstrumentStatus,
  setIsAutomationMode,
  setIsSimulationMode,
  setLabwareServiceStatus,
} from 'stores/actions/instrumentAction';
import {showBanner} from 'stores/actions/bannerStateAction';
import {FmlxAlert} from 'fmlx-common-ui';
import {batch} from 'react-redux';
import {upperCase} from 'lodash';
import {getInstrumentProcessStatus} from 'api/instrumentManagementApi';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {setAutosaveDisabled} from 'stores/actions/protocolEditorAction';
import {
  ApiRouteMap,
  CurrentStateEnum,
  FastRobotErrorcode,
  HostRepositoryStateName,
  InstrumentStatusType,
  RestAPIMethod,
  RuntimeMode,
  SignalREvent,
  SignalRHub,
} from '../../constants/dataEnum';
import {hideLoading, showLoading} from '../actions/appStateAction';
import {callAPI, getBaseURL, invokeAPI, resolveIntl} from './commonBusiness';
import {getLastFastInfo, setFastInfo} from './stateBusiness';
import {shouldUseLicense} from './licenseBusiness';
import {hideModal} from '../actions/modalStateAction';
import {WellLabel, WellType} from '../../contents/PlateTypeEditor/PlateTypeEditorEnum';
import {findKeyByValue} from '../../lib/objectHelper';
import {removeInstrumentNonOperationalModalConfig} from './errorHandlers/serviceErrorBusiness';
// #region invoke individual API

export const simulateProtocolError = (err) => async (dispatch) => {
  await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SIMULATE_PROTOCOL_ERROR, err));
};

export const setLEDIndicator = (statusCode) => async (dispatch) => {
  await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_LED_INDICATOR, statusCode));
};

export const getCurrentPosition = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_CURRENT_POSITION));

  console.log(SignalREvent.GET_CURRENT_POSITION, response);

  return response;
};

// to set the tray into backend
export const setTrayId = (trayInputValue, type) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_TRAY_ID, trayInputValue, type));

  console.log(SignalREvent.SET_TRAY_ID, response);

  return response;
};

// not to set the tray, only get the tray data (used for simulation only)
export const getTrayDataById = (trayInputValue, type) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_TRAY_DATA_BY_ID, trayInputValue, type),
  );

  console.log(SignalREvent.GET_TRAY_DATA_BY_ID, response);

  return response;
};

export const safeAlignToDeckInsertWithExtendedProbe = (id) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_ALIGN_TO_DECK_INSERT_WITH_EXTENDED_PROBE, id),
  );

  console.log(SignalREvent.SAFE_ALIGN_TO_DECK_INSERT_WITH_EXTENDED_PROBE, response);

  return response;
};

export const alignToDeckInsertWithOffset =
  (plateTypeEditorDeckInsert, wellLabel, startingPosition = null) =>
  async (dispatch) => {
    const wellTypeKey = findKeyByValue(WellLabel, (el) => el === wellLabel);
    const response = await dispatch(
      invokeAPI(
        SignalRHub.INSTRUMENT,
        SignalREvent.ALIGN_TO_DECK_INSERT_WITH_OFFSET,
        plateTypeEditorDeckInsert,
        WellType[wellTypeKey],
        startingPosition,
      ),
    );

    return response;
  };

export const safeTouchProbeRetract = () => async (dispatch) => {
  const useLicense = await dispatch(shouldUseLicense());
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_TOUCH_PROBE_RETRACT, useLicense));

  console.log(SignalREvent.SAFE_TOUCH_PROBE_RETRACT, response);

  return response;
};

export const safeTouchProbeExtend =
  (extendZPosition = 0, touchProbeExtendedProperly = false) =>
  async (dispatch) => {
    console.log(touchProbeExtendedProperly);
    const intl = resolveIntl();
    await dispatch(
      showLoading(
        intl.formatMessage({
          id: 'trayCalibrationContainer.loading.onExtendTouchProbe',
        }),
      ),
    );
    const response = await dispatch(
      invokeAPI(
        SignalRHub.INSTRUMENT,
        SignalREvent.SAFE_TOUCH_PROBE_EXTEND,
        extendZPosition,
        touchProbeExtendedProperly,
      ),
    );
    console.log(SignalREvent.SAFE_TOUCH_PROBE_EXTEND, response);
    await dispatch(hideLoading());
    return response;
  };

export const safeAutoCalibration = (targetDeck, isResume) => async (dispatch, getState) => {
  const {sessionState} = getState();
  const {user} = sessionState;

  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_AUTO_CALIBRATION, user.username, targetDeck, isResume),
  );

  console.log(SignalREvent.SAFE_AUTO_CALIBRATION, response);

  return response;
};

export const getStatusAutoCalibration = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_STATUS_AUTO_CALIBRATION));

  console.log(SignalREvent.GET_STATUS_AUTO_CALIBRATION, response);

  return response;
};

export const pauseAutoCalibration = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.PAUSE_AUTO_CALIBRATION, true));

  console.log(SignalREvent.PAUSE_AUTO_CALIBRATION, response);

  return response;
};

export const resumeAutoCalibration = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.RESUME_AUTO_CALIBRATION));

  console.log(SignalREvent.RESUME_AUTO_CALIBRATION, response);

  return response;
};

export const abortAutoCalibration = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ABORT_AUTO_CALIBRATION));

  console.log(SignalREvent.ABORT_AUTO_CALIBRATION, response);

  return response;
};

export const setCalibrationData = (deckInsertID, x, y, z) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_CALIBRATION_DATA, deckInsertID, x, y, z),
  );

  console.log(SignalREvent.SET_CALIBRATION_DATA, response);

  return response;
};

export const safeMoveTray = (currentYVal) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_MOVE_TRAY, currentYVal));

  console.log(SignalREvent.SAFE_MOVE_TRAY, response);

  return response;
};

export const forceMoveTrayRelative = (currentYVal) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.FORCE_MOVE_TRAY_RELATIVE, currentYVal));

  console.log(SignalREvent.FORCE_MOVE_TRAY_RELATIVE, response);

  return response;
};

export const safeMoveVerticalCarrier = (zVal) => async (dispatch) => {
  const useLicense = await dispatch(shouldUseLicense());
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_MOVE_VERTICAL_CARRIER, zVal, useLicense),
  );

  console.log(SignalREvent.SAFE_MOVE_VERTICAL_CARRIER, response);

  return response;
};

export const moveVerticalCarrierExt = (position, velocity, acceleration) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MOVE_VERTICAL_CARRIER_EXT, position, velocity, acceleration),
  );

  console.log(SignalREvent.MOVE_VERTICAL_CARRIER_EXT, response);

  return response;
};

export const forceMoveVerticalCarrierRelative = (zVal) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.FORCE_MOVE_VERTICAL_CARRIER_RELATIVE, zVal),
  );

  console.log(SignalREvent.FORCE_MOVE_VERTICAL_CARRIER_RELATIVE, response);

  return response;
};

export const safeMoveHorizontalCarrier = (xVal) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_MOVE_HORIZONTAL_CARRIER, xVal));

  console.log(SignalREvent.SAFE_MOVE_HORIZONTAL_CARRIER, response);

  return response;
};

export const forceMoveHorizontalCarrierRelative = (xVal) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.FORCE_MOVE_HORIZONTAL_CARRIER_RELATIVE, xVal),
  );

  console.log(SignalREvent.FORCE_MOVE_HORIZONTAL_CARRIER_RELATIVE, response);

  return response;
};

export const moveTrayRelativeWithExtendedProbe = (yVal) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MOVE_TRAY_RELATIVE_WITH_EXTENDED_PROBE, yVal),
  );

  console.log(SignalREvent.MOVE_TRAY_RELATIVE_WITH_EXTENDED_PROBE, response);

  return response;
};

export const moveVerticalCarrierRelativeWithExtendedProbe = (zVal) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MOVE_VERTICAL_CARRIER_RELATIVE_WITH_EXTENDED_PROBE, zVal),
  );

  console.log(SignalREvent.MOVE_VERTICAL_CARRIER_RELATIVE_WITH_EXTENDED_PROBE, response);

  return response;
};

export const moveHorizontalCarrierRelativeWithExtendedProbe = (xVal) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MOVE_HORIZONTAL_CARRIER_RELATIVE_WITH_EXTENDED_PROBE, xVal),
  );

  console.log(SignalREvent.MOVE_HORIZONTAL_CARRIER_RELATIVE_WITH_EXTENDED_PROBE, response);

  return response;
};

export const ejectTray = () => async (dispatch) => {
  const useLicense = await dispatch(shouldUseLicense());
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.EJECT_TRAY, useLicense));

  console.log(SignalREvent.EJECT_TRAY, response);

  return response;
};

// plateSurfaceTouchDirection: (1) is touch at X axis, (2) is touch at Y axis
export const measureWell =
  (
    deckInsert,
    // eslint-disable-next-line default-param-last
    plateSurfaceTouchDirection = 1,
    wellLabel,
  ) =>
  async (dispatch) => {
    const wellTypeKey = findKeyByValue(WellLabel, (el) => el === wellLabel);

    const response = await dispatch(
      invokeAPI(
        SignalRHub.INSTRUMENT,
        SignalREvent.MEASURE_WELL,
        deckInsert,
        plateSurfaceTouchDirection,
        WellType[wellTypeKey],
      ),
    );

    console.log(SignalREvent.MEASURE_WELL, response);

    return response;
  };

export const isTrayInstalled = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_TRAY_INSTALLED));

  console.log(SignalREvent.IS_TRAY_INSTALLED, response);

  return response;
};

export const isTouchProbeExpanded = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_TOUCH_PROBE_EXPANDED));

  console.log(SignalREvent.IS_TOUCH_PROBE_EXPANDED, response);

  return response;
};

export const moveToIdlePosition =
  (isShowLoading = true) =>
  async (dispatch) => {
    const intl = resolveIntl();
    if (isShowLoading) dispatch(showLoading(intl.formatMessage({id: 'runtime.movingToIdleLoading'})));

    const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_MOVE_TO_IDLE_POSITION));

    console.log(SignalREvent.SAFE_MOVE_TO_IDLE_POSITION, response);

    if (isShowLoading) dispatch(hideLoading());

    return response;
  };

export const checkRunningProtocolState = (state) => async (dispatch) => {
  const instrumentStatus = await dispatch(getInstrumentStatus());

  return instrumentStatus?.currentState === state;
};

/**
 * API to resume ongoing protocol execution
 * @param {Boolean} isReleaseTip condition if the tip should be released or not
 * @param {Boolean} isRecovery currently used to show recovery loading upon receiving event resumeProtocolStart and toast on resumeProtocolEnd
 * @param {Boolean} isResume currently used to set the runtimeStatus to RUNNING upon receiving event resumeProtocolEnd
 * @returns {Object} resume response object
 */
export const resumeProtocol =
  (isReleaseTip = false, isRecovery = false, isResume = true) =>
  async (dispatch) => {
    const isAlreadyRunning = await dispatch(checkRunningProtocolState(CurrentStateEnum.RUNNING));
    if (isAlreadyRunning) return FastRobotErrorcode.NoError;

    const response = await dispatch(
      invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.RESUME_PROTOCOL, isReleaseTip, isRecovery, isResume),
    );

    console.log(SignalREvent.RESUME_PROTOCOL, response);

    return response;
  };

export const pauseProtocol =
  (isHardPause, usernameRequester = '') =>
  async (dispatch) => {
    const isAlreadyPaused = await dispatch(checkRunningProtocolState(CurrentStateEnum.PAUSED));
    if (isAlreadyPaused) return FastRobotErrorcode.NoError;

    const response = await dispatch(
      invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.PAUSE_PROTOCOL, isHardPause, usernameRequester),
    );

    console.log(SignalREvent.PAUSE_PROTOCOL, response);

    return response;
  };

export const abortProtocol =
  (abortOption, usernameRequester = '') =>
  async (dispatch) => {
    const response = await dispatch(
      invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ABORT_PROTOCOL, abortOption, usernameRequester),
    );

    console.log(SignalREvent.ABORT_PROTOCOL, response);

    if (response.errorCode !== FastRobotErrorcode.NoError) {
      dispatch(hideLoading());
    }

    return response;
  };

export const abortActionBatch =
  (usernameRequester = '') =>
  async (dispatch, getState) => {
    try {
      const {runtimeState} = getState();
      const {abortParam} = runtimeState;

      dispatch(hideModal());

      const response = await dispatch(abortProtocol(abortParam, usernameRequester));

      if (response.errorCode !== FastRobotErrorcode.NoError) {
        dispatch(hideLoading());
      }
    } catch (error) {
      console.log('Runtime->abortActionBatch', SignalREvent.ABORT_PROTOCOL, 'error', error);
    }
  };

export const closeRuntimeView = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CLOSE_RUNTIME_VIEW));

  console.log(SignalREvent.CLOSE_RUNTIME_VIEW, response);

  return response;
};

export const setProtocolTip = (selectedTip, deckInsert) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_PROTOCOL_TIP, selectedTip, deckInsert),
  );

  console.log(SignalREvent.SET_PROTOCOL_TIP, response);

  return response;
};

export const getFastInfo = () => async (dispatch) => {
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.COLLECT_FAST_INFO));
    dispatch(setFastInfo(response));
  } catch (err) {
    console.log(err);
    response = await dispatch(getLastFastInfo());
  }

  if (!response) return null;

  const {tipClampAttachCounter, tipClampFullyReleaseCounter} = await dispatch(getTipClampStatistic());

  const fastInfoResponse = {...response, tipPlungerUsageCycle: tipClampAttachCounter + tipClampFullyReleaseCounter};

  dispatch(setSystemInformationData(fastInfoResponse));

  return fastInfoResponse;
};

export const safeRecoveryProbe = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_RECOVERY_PROBE));

  console.log(SignalREvent.SAFE_RECOVERY_PROBE, response);

  return response;
};

export const getInstrumentStatus = () => async (dispatch) => {
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_STATUS));
  } catch (err) {
    console.log(err);
  }

  return response;
};

export const getAllMotorStatus = () => async (dispatch) => {
  dispatch(showLoading('connecting to instrument'));
  try {
    const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_ALL_MOTOR_STATUS));
    console.log(SignalREvent.GET_ALL_MOTOR_STATUS, response);
    dispatch(hideLoading());
    return response;
  } catch (error) {
    console.log('getAllMotorStatus err', error);
    dispatch(hideLoading());
    return null;
  }
};

export const visionCompatibilityCheck = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.VISION_COMPATIBILITY_CHECK));

  console.log(SignalREvent.VISION_COMPATIBILITY_CHECK, response);

  return response;
};

// #endregion invoke individual API

// #region invoke custom API
export const checkTouchProbeAndEjectTray = () => async (dispatch) => {
  let response;

  const isExpanded = await dispatch(isTouchProbeExpanded());

  if (isExpanded) {
    response = await dispatch(safeTouchProbeRetract());
  }

  response = await dispatch(ejectTray());

  return response;
};

// #endregion invoke custom API

// #region tip clamp counter

export const getMaxTipClampConfig = () => async (dispatch) => {
  try {
    const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_STATISTIC_CONFIG));

    return response;
  } catch (error) {
    return null;
  }
};

export const getTipClampStatistic = () => async (dispatch) => {
  try {
    const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_STATISTIC_DOC));

    return response;
  } catch (error) {
    return null;
  }
};

// #endregion tip clamp counter

// #region preparation wizard

export const getTargetMails = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_TARGET_MAILS));

  console.log(SignalREvent.GET_TARGET_MAILS, 'response:', response);

  return response;
};

export const setAutomatedErrorReport = (alias, targetMail) => async (dispatch) => {
  let response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.UPDATE_CLIENT_ALIAS, alias));
  console.log(SignalREvent.UPDATE_CLIENT_ALIAS, 'response:', response);

  response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.UPDATE_TARGET_MAIL, targetMail));
  console.log(SignalREvent.UPDATE_TARGET_MAIL, 'response:', response);

  return response;
};

export const calibrateCollision = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CALIBRATE_COLLISION));

  console.log(SignalREvent.CALIBRATE_COLLISION, 'response:', response);

  return response;
};

export const alignToDeckCaddy = (additionalMoveUpDistance) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ALIGN_TO_DECK_CADDDY, additionalMoveUpDistance),
  );

  console.log(SignalREvent.ALIGN_TO_DECK_CADDDY, 'response:', response);

  return response;
};

export const alignXYZ = (x, y, z) => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ALIGN_X_Y_Z, x, y, z));

  console.log(SignalREvent.ALIGN_X_Y_Z, 'response:', response);

  return response;
};

export const checkTipPickUp = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CHECK_TIP_PICK_UP));

  console.log(SignalREvent.CHECK_TIP_PICK_UP, 'response:', response);

  return response;
};

// #region a1 offset

export const updateA1Offset = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.UPDATE_A1_OFFSET));

  console.log(SignalREvent.UPDATE_A1_OFFSET, 'response:', response);

  return response;
};

// Obsolete. No longer use metadata to check tray shifts
export const isA1OffsetMetadataExist = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_A1_OFFSET_METADATA_EXIST));

  console.log(SignalREvent.IS_A1_OFFSET_METADATA_EXIST, 'response:', response);

  return response;
};

export const isA1OffsetCalibrated = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_A1_OFFSET_CALIBRATED));

  console.debug(SignalREvent.IS_A1_OFFSET_CALIBRATED, 'response:', response);

  return response;
};

export const scanYawSequence = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SCAN_YAW_SEQUENCE));

  console.log(SignalREvent.SCAN_YAW_SEQUENCE, 'response:', response);

  return response;
};

export const resetDataMarkerPosition = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.RESET_DATA_MARKER_POSITION));

  console.log(SignalREvent.RESET_DATA_MARKER_POSITION, 'response:', response);

  return response;
};

export const alignToDeckCaddyAfterSetMarkerA1 = () => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.ALIGN_TO_DECK_CADDY_AFTER_SET_MARKER_A1),
  );

  console.log(SignalREvent.ALIGN_TO_DECK_CADDY_AFTER_SET_MARKER_A1, 'response:', response);

  return response;
};

export const setMarkerPositionAfterUpdateA1 = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SET_MARKER_POSITION_AFTER_UPDATE_A1));

  console.log(SignalREvent.SET_MARKER_POSITION_AFTER_UPDATE_A1, 'response:', response);

  return response;
};

/**
 * Auto A1 offset calibration for FAST V2 only
 */
export const safeAutoA1OffsetCalibration = () => async (dispatch, getState) => {
  const {sessionState} = getState();
  // eslint-disable-next-line no-unsafe-optional-chaining
  const {username} = sessionState?.user;

  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAFE_AUTO_A1_OFFSET_CALIBRATION, username),
  );

  console.log(SignalREvent.SAFE_AUTO_A1_OFFSET_CALIBRATION, 'response:', response);

  return response;
};

export const getAutoA1OffsetCalibrationStatus = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_STATUS_AUTO_A1_OFFSET_CALIBRATION));

  console.log(SignalREvent.GET_STATUS_AUTO_A1_OFFSET_CALIBRATION, 'response:', response);

  return response;
};
// #endregion a1 offset

export const isSlantedDetectionSkipped = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.IS_SLANTED_DETECTION_SKIPPED));

  console.log(SignalREvent.IS_SLANTED_DETECTION_SKIPPED, 'response:', response);

  return response;
};

export const calibrateScanTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CALIBRATE_SCAN_TIPS));

  console.log(SignalREvent.CALIBRATE_SCAN_TIPS, 'response:', response);

  return response;
};

export const calibrateScanSlantedTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CALIBRATE_SCAN_SLANTED_TIPS));

  console.log(SignalREvent.CALIBRATE_SCAN_SLANTED_TIPS, 'response:', response);

  return response;
};

export const calibrateScanStuckTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.CALIBRATE_SCAN_STUCK_TIPS));

  console.log(SignalREvent.CALIBRATE_SCAN_STUCK_TIPS, 'response:', response);

  return response;
};

export const preMoveCalibrateScanStuckTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.PRE_MOVE_CALIBRATE_SCAN_STUCK_TIPS));

  console.log(SignalREvent.PRE_MOVE_CALIBRATE_SCAN_STUCK_TIPS, 'response:', response);

  return response;
};

export const postMoveCalibrateScanStuckTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.POST_MOVE_CALIBRATE_SCAN_STUCK_TIPS));

  console.log(SignalREvent.POST_MOVE_CALIBRATE_SCAN_STUCK_TIPS, 'response:', response);

  return response;
};

// #endregion preparation wizard

// #region manual reteach plate definition
export const postManualReteachScanTips =
  (
    username,
    labwareID,
    ID_DECK,
    colTipCount,
    rowTipCount,
    row,
    col,
    ignoreError,
    groupIndex, // zero (0), except the IFC
  ) =>
  async (dispatch) => {
    const response = await dispatch(
      invokeAPI(
        SignalRHub.INSTRUMENT,
        SignalREvent.MANUAL_RETEACH_PLATE_SCANNING_TIPS,
        username,
        labwareID,
        ID_DECK,
        colTipCount,
        rowTipCount,
        row,
        col,
        ignoreError,
        groupIndex,
      ),
    );

    console.log(SignalREvent.MANUAL_RETEACH_PLATE_SCANNING_TIPS, 'response:', response);

    return response;
  };

export const postManualReteachReturnTips = (username, returnToCaddy) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MANUAL_RETEACH_PLATE_RETURN_TIPS, username, returnToCaddy),
  );

  console.log(SignalREvent.MANUAL_RETEACH_PLATE_RETURN_TIPS, 'response:', response);
  dispatch(setManualReteachReturnToCaddy(returnToCaddy));

  return response;
};

export const getStatusManualPlate = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MANUAL_RETEACH_PLATE_GET_STATUS));

  console.log(SignalREvent.MANUAL_RETEACH_PLATE_GET_STATUS, 'response:', response);

  return response;
};

export const checkManualPlateDefinitionLabware = (labwareId) => async (dispatch) => {
  const response = await dispatch(
    invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.MANUAL_RETEACH_PLATE_CHECK_LABWARE, labwareId),
  );

  console.log(SignalREvent.MANUAL_RETEACH_PLATE_CHECK_LABWARE, 'response:', response);

  return response;
};

export const recoveryEjectAndScanStuckTips = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.RECOVERY_EJECT_AND_SCAN_STUCK_TIPS));

  console.log(SignalREvent.RECOVERY_EJECT_AND_SCAN_STUCK_TIPS, 'response:', response);

  return response;
};
// #endregion manual reteach plate definition

// #region check simulation mode
export const getIsSimulationMode = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_SIMULATION));

  console.log(SignalREvent.GET_SIMULATION, 'response:', response);

  dispatch(setIsSimulationMode(response));
  return response;
};

export const getIsAutomationMode = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_AUTOMATION));

  console.log(SignalREvent.GET_AUTOMATION, 'response:', response);

  dispatch(setIsAutomationMode(response));
  return response;
};
// #endregion check simulation mode

export const getServiceOperationalStatus = () => async (dispatch) => {
  const intl = resolveIntl();
  const baseUrl = getBaseURL(HostRepositoryStateName.AUTHORING);
  let response = {};
  let instrumentProcessStatus = {};

  try {
    response = await callAPI(RestAPIMethod.GET, baseUrl, ApiRouteMap.GET_CHECK_ALL_SERVICES_OPERATIONAL);
    instrumentProcessStatus = await getInstrumentProcessStatus();
  } catch (error) {
    console.error('getServiceOperationalStatus error:', error);
    response = {
      instrumentOperationalStatus: 'NoError',
      labwareAppOperationalStatus: 'NoError',
    };
  }

  batch(() => {
    dispatch(
      setInstrumentServiceStatus({
        hasError: response.instrumentOperationalStatus?.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase(),
        errorCode: response.instrumentOperationalStatus,
      }),
    );
    dispatch(
      setLabwareServiceStatus({
        hasError: response.labwareAppOperationalStatus?.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase(),
        errorCode: response.labwareAppOperationalStatus,
      }),
    );
  });

  if (response.instrumentOperationalStatus?.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    dispatch(showBanner(FmlxAlert.Severity.ERROR, intl.formatMessage({id: 'common.banner.fastInstrumentNotDetected'})));
    dispatch(setInstrumentStatus(InstrumentStatusType.NON_OPERATIONAL));
    dispatch(setAutosaveDisabled());
  } else {
    if (instrumentProcessStatus?.status === InstrumentProcessType.IDLE) {
      dispatch(setInstrumentStatus(InstrumentStatusType.OPERATIONAL));
    }

    removeInstrumentNonOperationalModalConfig();
  }
};

export const setInstrumentBasedOnRuntimeState = (runtimeState) => (dispatch) => {
  if (!runtimeState) return;

  const {currentState: currentRuntimeState = '', lastEvent = {}} = runtimeState;
  const currentState = upperCase(currentRuntimeState);

  switch (currentState) {
    case RuntimeMode.RUNNING: {
      dispatch(setInstrumentStatus(InstrumentStatusType.RUNNING));
      break;
    }
    case RuntimeMode.PAUSED: {
      if (
        lastEvent.messageType.toLowerCase() === SignalREvent.USER_CONFIRMATION_DIALOG.toLowerCase() ||
        lastEvent.messageType.toLowerCase() === SignalREvent.DELAY_DIALOG.toLowerCase()
      ) {
        dispatch(setInstrumentStatus(InstrumentStatusType.NEED_USER_ATTENTION));
      } else {
        dispatch(setInstrumentStatus(InstrumentStatusType.PAUSED));
      }
      break;
    }
    default: {
      dispatch(setInstrumentStatus(InstrumentStatusType.IDLE));
      break;
    }
  }
};
